export const AppService = {



  originalState(__objectModule,__property){
    let val = JSON.parse(localStorage.getItem('vuex-tons'))
    if(val.hasOwnProperty(`${__objectModule}`)){
      if(val[`${__objectModule}`].hasOwnProperty(`${__property}`)){
        return val[`${__objectModule}`][`${__property}`]
      }
    }
  },
};

export default {AppService};
